export const formatDate = () => {
    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

export const INITIAL_STATE = {
    Customer_Name:"",
    Order_Number:"",
    Customer_Phone:"",
    Description:"",
    Custome_Service: 0,
    Due_Date:"",
    Tax: true,
    archive: false,
    Hem_Without_horse_hair: "0",
    Hem_With_horse_hair: "0",
    Hem_sleeves: "0",
    Take_in_bust: "0",
    Take_in_back: "0",
    Take_in_sides_beads: "0",
    Take_in_shouldes: "0",
    Take_in_sleeves: "0",
    Take_in_straps: "0",
    Take_in_bach_zipper: "0",
    Take_in_neck: "0",
    Date : new Date()
  
};

export const formReducer = (state, action) => {
    switch (action.type){
        case "CHANGE_INPUT":
            return{
                ...state,
                [action.payload.name]:action.payload.value
            };
        default:
            return state;
    }
}